
export enum SidenavState {
    PINNED, FLOATING
}
